export default __webpack_public_path__ + "static/media/acceptInvitationBlue.4ffe3835.svg";